import styled from 'styled-components';
export var Wrapper = styled.div.withConfig({
  displayName: "CareAddedstyles__Wrapper",
  componentId: "sc-1sx6nob-0"
})(["display:flex;"]); // The width matches the width of the product image on the page basket

export var IconContainer = styled.div.withConfig({
  displayName: "CareAddedstyles__IconContainer",
  componentId: "sc-1sx6nob-1"
})(["width:90px;height:80px;margin-right:20px;display:flex;align-items:center;justify-content:center;flex-shrink:0;@media (min-width:", "){width:80px;}@media (min-width:", "){width:110px;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
}, function (props) {
  return props.theme.size.breakpoint['max-width'].lg;
});
export var ContentContainer = styled.div.withConfig({
  displayName: "CareAddedstyles__ContentContainer",
  componentId: "sc-1sx6nob-2"
})(["display:flex;flex-wrap:wrap;flex-grow:1;justify-content:space-between;padding-top:16px;align-items:flex-start;"]);
export var Title = styled.p.withConfig({
  displayName: "CareAddedstyles__Title",
  componentId: "sc-1sx6nob-3"
})(["width:100%;@media (min-width:", "){width:auto;flex:2;margin-right:40px;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});
export var CTA = styled.div.withConfig({
  displayName: "CareAddedstyles__CTA",
  componentId: "sc-1sx6nob-4"
})(["@media (min-width:", "){flex:0 0 auto;margin-right:40px;width:80px;text-align:center;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});
export var PriceWrapper = styled.div.withConfig({
  displayName: "CareAddedstyles__PriceWrapper",
  componentId: "sc-1sx6nob-5"
})(["display:flex;flex-direction:column;align-items:flex-end;@media (min-width:", "){width:120px;}"], function (props) {
  return props.theme.size.breakpoint['min-width'].lg;
});
export var Price = styled.div.withConfig({
  displayName: "CareAddedstyles__Price",
  componentId: "sc-1sx6nob-6"
})(["font-size:1.25rem;font-weight:", ";"], function (props) {
  return props.theme.font.weight.bold;
});
export var UnitPrice = styled.div.withConfig({
  displayName: "CareAddedstyles__UnitPrice",
  componentId: "sc-1sx6nob-7"
})(["display:flex;justify-content:flex-end;font-size:", ";line-height:14px;"], function (props) {
  return props.theme.font.size.caption;
});